import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import BasicDialog from "../../base/BasicDialog";
import { Button, Grid } from "@mui/material";
import { isEmptyValue } from "../../../helpers/methods";
import { useForm } from "../../../hooks/useForm";
import DateField from "../../field/DateField/DateField";

const SelectDateDialog = (props) => {
  const { t } = useTranslation();

  const {
    formValue,
    onChangeDate
  } = useForm({ selectedDate: props.initDate });


  return (
    <BasicDialog
      open={props.open}
      onClose={() => {
        props.onClose();
      }}
      titleAlign="center"
      maxWidth="sm"
      title={t("dialog.select_date_dialog.select_date")}
    >
      <Grid item xs={12}>
        <DateField
          name="selectedDate"
          label={t("dialog.select_date_dialog.selected_date")}
          value={formValue?.selectedDate}
          onChange={onChangeDate}
          required
          minDate={props.minDate}
          maxDate={props.maxDate}
        />
      </Grid>
      <Grid item xs={12}>
        <Button
          sx={{ marginTop: "20px" }}
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => props.onSubmit(formValue?.selectedDate)}
          disabled={isEmptyValue(formValue?.selectedDate)}
        >
          {t("add")}
        </Button>
      </Grid>
    </BasicDialog>
  );
};

SelectDateDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  initDate: PropTypes.string,
};

SelectDateDialog.defaultProps = {
  open: false,
};

export default SelectDateDialog;
